import { Module, ActionContext } from 'vuex'
import { RootState, PipelineState } from '../store/state_models'
import opportunityService from '@/services/OpportunityServices'


export const pipelines: Module<PipelineState, RootState> = {
  namespaced: true,
  state: { pipelines: [], locationId: undefined, isLoading: false },
  getters: {
    getById: (state: PipelineState) => {
      return (id: string) => state.pipelines.find(x => x.id === id)
    },

    isLoading: (state: PipelineState) => {
      return state.isLoading;
    }
  },
  mutations: {
    addUpdate: (state: PipelineState, payload: { pipelines: any[], locationId: string } ) => {
      state.pipelines = payload.pipelines
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    clearAll: (state: PipelineState) => {
      state.pipelines = []
      state.locationId = undefined
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<PipelineState, RootState>,
      params: string | {locationId:string,forceRefresh?:boolean}
    ) {
      let locationId
      let forceRefresh = false
      context.state.isLoading = false;
      if(typeof params === 'object')
      {
        locationId = params.locationId
        forceRefresh = Boolean(params.forceRefresh)
      } else {
        locationId = params
      }
      if (!locationId) {
        context.commit('clearAll')
        return
      }

      if (context.state.locationId === locationId && !forceRefresh) {
        return context.state.pipelines;
      }

      
      return new Promise((resolve, reject) => {

        opportunityService.getPipelines(locationId).then(({pipelines})=>{
          pipelines = pipelines.map(pipeline=>{
            pipeline.date_added = pipeline.dateAdded
            pipeline.date_updated = pipeline.dateUpdated
            delete pipeline.date_added
            delete pipeline.date_updated
            return pipeline
          })
          context.commit('clearAll')
          context.commit('addUpdate', {
            locationId: locationId,
            pipelines
        })
        context.state.isLoading = true;
        resolve(context.state.pipelines.pipelines)
      }).catch((err)=>{
        context.state.isLoading = true;
        resolve()
      })
      
      })
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<PipelineState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<PipelineState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
